import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Async, Button, FilterPills, PageHeader, Panel } from '../ui';
import useFetch from '../useFetch';
import { useDash } from '../DashboardShell';
import { exportResellers } from './exportResellers';
import { AddResellerModal, PayoutModal, ResellerDetailModal } from './AdminModals';
import ResellerTable from './ResellerTable';

const Resellers = () => {
  const { notify } = useDash();
  const [params, setParams] = useSearchParams();
  const status = params.get('status') || '';
  const [adding, setAdding] = useState(false);
  const [viewId, setViewId] = useState(null);
  const [payFor, setPayFor] = useState(null);

  // The table searches, sorts and pages in the browser, so fetch the whole list (up to 1000).
  const state = useFetch('/admin/resellers', { limit: 1000, ...(status ? { status } : {}) });
  const setStatus = (value) => setParams(value ? { status: value } : {});
  const startPay = (r) => {
    setViewId(null);
    setPayFor(r);
  };

  return (
    <>
      <PageHeader eyebrow="Manage" title="Resellers">
        <Button onClick={() => exportResellers(status ? { status } : {}, notify)}>Export CSV</Button>
        <Button variant="primary" onClick={() => setAdding(true)}>Add reseller</Button>
      </PageHeader>

      <Panel>
        <Async state={state}>
          {(d) => (
            <>
              <div style={{ marginBottom: 14 }}>
                <FilterPills
                  label="Filter by status"
                  value={status}
                  onChange={setStatus}
                  options={[
                    { value: '', label: 'All', count: d.counts.all },
                    { value: 'active', label: 'Active', count: d.counts.active },
                    { value: 'pending', label: 'Pending', count: d.counts.pending },
                    { value: 'suspended', label: 'Inactive', count: d.counts.suspended },
                  ]}
                />
              </div>
              <ResellerTable rows={d.items} onView={(r) => setViewId(r.id)} onPay={startPay} emptyText={status ? 'No resellers with this status.' : 'Add your first reseller to get started.'} />
              {d.total > d.items.length && <p className="ds-foot">Showing the newest {d.items.length} of {d.total} resellers.</p>}
            </>
          )}
        </Async>
      </Panel>

      <AddResellerModal open={adding} onClose={() => setAdding(false)} onDone={state.reload} />
      <ResellerDetailModal resellerId={viewId} onClose={() => setViewId(null)} onChanged={state.reload} onPay={startPay} />
      <PayoutModal open={!!payFor} reseller={payFor} onClose={() => setPayFor(null)} onDone={state.reload} />
    </>
  );
};

export default Resellers;
